// React and router
import React from 'react';
import { BrowserRouter, Prompt, Route, Switch } from 'react-router-dom';
import { connect } from 'react-redux';
import Layout from './containers/Layout';
import PrivateRoute from './containers/PrivateRoute';
// Containers
import DemoContent from './containers/SalesOrders/SalesOrders';
import Logout from './containers/Logout';

import Loadable from 'react-loadable';
import Loading from './components/Loading';



const Broadcast = Loadable({
	loader: () => import('./containers/Broadcast' /* webpackChunkName: "Broadcast" */),
	loading: Loading, delay: 300,
});
const DataViewer = Loadable({
	loader: () => import('./containers/DataViewer' /* webpackChunkName: "DataViewer" */),
	loading: Loading, delay: 300,
});
const BusinessPartners = Loadable({
	loader: () => import('./containers/BusinessPartners' /* webpackChunkName: "BusinessPartners" */),
	loading: Loading, delay: 300,
});
const Accounting = Loadable({
	loader: () => import('./containers/Accounting' /* webpackChunkName: "Accounting" */),
	loading: Loading, delay: 300,
});
const Reports = Loadable({
	loader: () => import('./containers/Reports' /* webpackChunkName: "Reports" */),
	loading: Loading, delay: 300,
});
const Home = Loadable({
	loader: () => import('./containers/Home' /* webpackChunkName: "Home" */),
	loading: Loading, delay: 300,
});



class Router extends React.Component {
	render() {
		return (
			<BrowserRouter>
				<Route
					render={( { location } ) => (
						<Layout location={location}>
							<Prompt
								when={(this.props.bpChanged || this.props.orderChanged)}
								message="You have unsaved changes.  Are you sure you want to leave this page?"
							/>
							<Switch
								location={location}
								key={location.key}
							>
								<PrivateRoute
									exact
									path="/"
									component={Home}
								/>
								<PrivateRoute
									exact
									path="/salesorders"
									component={DemoContent}
								/>
								<PrivateRoute
									exact
									path="/accounting"
									component={Accounting}
								/>
								<PrivateRoute
									exact
									path="/reports"
									component={Reports}
								/>
								<PrivateRoute
									exact
									path="/dataviewer"
									component={DataViewer}
								/>
								<PrivateRoute
									exact
									path="/broadcast"
									component={Broadcast}
								/>
								<PrivateRoute
									path="/businesspartners/:mode?/:id?/:altMode?/:altModeID?"
									component={BusinessPartners}
								/>
								<Route
									exact
									path="/logout"
									component={Logout}
								/>
							</Switch>
						</Layout>
					)}
				/>
			</BrowserRouter>
		)
	}
}



const mapStateToProps = state => {
	return {
		bpChanged: state.businessPartners.blockRouting,
		orderChanged: state.salesOrders.hasChanged,
	};
};


export default connect(mapStateToProps)(Router);